// 3桁カンマ区切りとする（小数点の丸め込みが起こらないように考慮）
export function comma(num: number) {
  const s = String(num).split('.');
  let ret = String(s[0]).replace( /(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
  if (s.length > 1) {
      ret += '.' + s[1];
  }
  return ret;
}